<template>
  <div id="staff-list-table">
    <v-data-table
      :headers="tableHeaders"
      :items="staff"
      hide-default-footer
      :items-per-page="pagination.per_page"
    >
      <!--<editor-fold desc="ITEM SLOT">-->
      <template v-slot:item="{ item: staffMember }">
        <tr>
          <td>
            <div class="d-flex align-center">
              <v-avatar
                size="32"
                class="mr-2"
                color="grey lighten-2"
              >
                <v-img :src="staffMember.photo_url">
                  <template v-slot:placeholder>
                    <v-icon x-small>
                      fal fa-user
                    </v-icon>
                  </template>
                </v-img>
              </v-avatar>
              {{ staffMember.first_name }} {{ staffMember.last_name }}
            </div>
          </td>
          <td v-if="!hasNoPlayers">
            <v-chip
              v-for="team in staffMember.teams"
              :key="'team_'+team.id"
              small
              outlined
              class="mr-1"
            >
              {{ team.name }}
            </v-chip>
          </td>
          <td>{{ staffMember.phone }}</td>
          <td>{{ staffMember.email }}</td>
          <td>
            <div v-if="staffMember.user">
              <v-chip
                v-if="staffMember.user.is_setup_complete"
                small
                color="success"
              >
                {{ $t('status.account_setup.complete') }}
              </v-chip>
              <v-chip
                v-else-if="staffMember.user.is_invitation_expired"
                small
                color="error"
              >
                {{ $t('status.account_setup.expired') }}
                <v-icon
                  x-small
                  class="ml-2"
                >
                  far fa-triangle-exclamation
                </v-icon>
              </v-chip>
              <v-chip
                v-else
                small
              >
                {{ $t('status.account_setup.pending') }}
              </v-chip>
            </div>
            <span
              v-else
              class="grey--text"
            >
              N/A
            </span>
          </td>
          <td style="width: 0;">
            <v-btn
              icon
              @click="$emit('edit', staffMember)"
            >
              <v-icon small>
                fal fa-edit
              </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="PROGRESS SLOT">-->
      <template
        v-if="loading"
        v-slot:body
      >
        <tbody>
          <tr
            v-for="i in pagination.per_page"
            :key="i"
          >
            <td class="d-flex align-center">
              <div class="d-inline-flex align-center">
                <v-skeleton-loader
                  type="avatar"
                  class="mr-3"
                />
                <v-skeleton-loader
                  type="text"
                  width="100px"
                />
              </div>
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="100px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="100px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="60px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="60px"
              />
            </td>
            <td />
          </tr>
        </tbody>
      </template>
      <!--</editor-fold>-->
    </v-data-table>
    <div
      v-if="pagination && pagination.last_page > 1"
      class="d-flex justify-center align-center py-5"
    >
      <pagination
        v-model="pagination.current_page"
        :last-page="pagination.last_page"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import i18n from '@/plugins/i18n'

export default {
  name: 'StaffListTable',
  components: { Pagination },
  props: {
    staff: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({}),
  computed: {
    tableHeaders() {
      return [
        { key: 'name', align: 'start', text: i18n.t('table_headers.name'), sortable: false },
        ...(!this.hasNoPlayers ? [{ key: 'teams', text: i18n.t('table_headers.admin_staff.teams'), sortable: false }] : []),
        { key: 'phone', text: i18n.t('table_headers.admin_staff.phone'), sortable: false },
        { key: 'email', text: i18n.t('table_headers.admin_staff.email'), sortable: false },
        { key: 'accountSetup', text: i18n.t('table_headers.admin_all_players.account_setup'), sortable: false },
        { key: 'actions', width: '1%', align: 'end', text: '', sortable: false }
      ]
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    hasNoPlayers() {
      return this.user.organisation_settings.has_no_players
    }
  }
}
</script>
